import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getGiveawayStatuses = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/briefs/giveaways/statuses' });

  return data;
};

export default getGiveawayStatuses;
